import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import TextInput from '../../../../components/ui/TextInput/TextInput'
import TextArea from '../../../../components/ui/TextArea/TextArea'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'
import Dropdown from '../../../../components/ui/Dropdown/Dropdown'
import CustomDropdown from '../../../../components/ui/CustomDropdown/CustomDropdown'
import Checkbox from '../../../../components/ui/Checkbox/Checkbox'

import { components as selectComponents } from 'react-select'

import { SHARE_FEEDBACK_TOPICS_REQUIRING_MALL } from '../../../../services/validation/ShareFeedback'

/**
 *    Registration & Profile
o        Card Linking
o        Points Earning
o        Rewards Redemption
o        Explore
o        Cinemas
o        Offers
o        Zing App Issues
 */

const topicList = [
  {
    name: 'Registration & Profile',
    value: 'registration',
  },
  // ST-7123 - Profile :: Help Center : Update Share Your Feedback
  // {
  //   name: 'Card Linking',
  //   value: 'card-linking',
  // },
  // ST-7339 - Profile :: Help Center : Remove Options
  // <--
  // {
  //   name: 'Points Earning',
  //   value: 'points-earning',
  // },
  // {
  //   name: 'Rewards Redemption',
  //   value: 'rewards-redemption',
  // },
  // -->
  {
    name: 'Explore',
    value: 'explore',
  },
  {
    name: 'Cinemas',
    value: 'cinema',
  },
  {
    name: 'Offers',
    value: 'offers',
  },
  {
    name: 'Zing App Issues',
    value: 'zing-app-issues',
  },
  {
    name: 'Be a Zing Merchant',
    value: 'zing-merchant',
  },
].map(({ name }) => ({ name, value: name }))

const ButtonWrapper = styled.div`
  margin: 1rem 0 0;
`

const BlockButton = styled(ActionButton)`
  width: 100%;
`

const FieldError = styled.output`
  display: block;
  color: var(--color-error);
  padding: 0 1rem;
  font-size: 0.75em;
  margin-top: 0.25rem;
  :empty {
    display: none;
  }
`

function MultiSelectOption(props) {
  const { isSelected, label } = props
  return (
    <selectComponents.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <div style={{ pointerEvents: 'none' }}>
          <Checkbox checked={isSelected} />
        </div>
        <span>{label}</span>
      </div>
    </selectComponents.Option>
  )
}

function ShareFeedbackPageForm(props) {
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    values,
    errors,
    touched,
    isSubmitting,
    isValid,
    disabled,
    method,
    action,
    accessToken,
    malls,
  } = props

  const mallOptions = (malls || []).map(mall => ({
    name: mall.name,
    value: mall.name,
    label: mall.name,
  }))
  const selectedMallOptions = mallOptions.filter(opt =>
    Array.isArray(values.malls) ? values.malls.includes(opt.value) : false,
  )

  return (
    <form onSubmit={handleSubmit} method={method} action={action}>
      <fieldset disabled={isSubmitting || disabled}>
        {!accessToken && (
          <>
            <TextInput
              name="name"
              type="text"
              placeholder="Full Name"
              initialValue={values.name}
              error={errors.name}
              touched={touched.name}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <TextInput
              name="email"
              type="text"
              placeholder="Email Address"
              initialValue={values.email}
              error={errors.email}
              touched={touched.email}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </>
        )}
        <Dropdown
          name="topic"
          placeholder="Select Topic"
          options={topicList}
          initialValue={values.topic}
          error={errors.topic}
          touched={touched.topic}
          onChange={handleChange}
        />
        {SHARE_FEEDBACK_TOPICS_REQUIRING_MALL.includes(values.topic) && (
          <>
            <CustomDropdown
              placeholder="Select Mall(s)"
              options={mallOptions}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              value={selectedMallOptions}
              components={{ Option: MultiSelectOption }}
              onChange={selected => {
                const next = Array.isArray(selected)
                  ? selected.map(o => o.value)
                  : []
                setFieldValue('malls', next)
              }}
              onBlur={() => setFieldTouched('malls', true)}
            />
            <FieldError>{touched.malls && errors.malls}</FieldError>
          </>
        )}
        <TextInput
          name="subject"
          type="text"
          placeholder="Subject"
          initialValue={values.subject}
          error={errors.subject}
          touched={touched.subject}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <TextArea
          name="message"
          placeholder="Your Message"
          rows={4}
          initialValue={values.message}
          error={errors.message}
          touched={touched.message}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <ButtonWrapper>
          <BlockButton type="submit" variant="primary" disabled={!isValid}>
            Submit
          </BlockButton>
        </ButtonWrapper>
      </fieldset>
    </form>
  )
}

ShareFeedbackPageForm.defaultProps = {
  handleSubmit: null,
  handleChange: null,
  handleBlur: null,
  setFieldValue: null,
  setFieldTouched: null,
  values: {},
  errors: {},
  touched: {},
  isSubmitting: false,
  isValid: false,
  disabled: false,
  method: 'get',
  action: '',
  status: {},
}

ShareFeedbackPageForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  setFieldValue: PropTypes.func,
  setFieldTouched: PropTypes.func,
  values: PropTypes.shape(),
  errors: PropTypes.shape(),
  touched: PropTypes.shape(),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  method: PropTypes.oneOf(['get', 'post']),
  action: PropTypes.string,
  status: PropTypes.shape(),
}

export default ShareFeedbackPageForm
